export default __webpack_public_path__ + "static/media/Surya.835bc994.jpg";